// mds-dojo — dojo/query. Returns an array of matched elements (dojo NodeList is
// array-like; the oracle only uses length / indexing / forEach). Supports an
// optional context node, and the "> child" combinator dojo allows.

export default function query(selector: string, context?: Element | Document | Node | string): any[] {
  let root: Element | Document = document;
  if (context) {
    root = (typeof context === 'string' ? (document.getElementById(context) as Element) : context) as Element | Document;
  }
  let sel = selector;
  let scopeRoot: Element | Document | DocumentFragment = root;
  // Rewrite a leading child combinator ("> foo") into :scope for querySelectorAll.
  if (/^\s*>/.test(sel)) {
    sel = ':scope ' + sel.trim();
  }
  let nodes: Element[];
  try {
    nodes = Array.prototype.slice.call((scopeRoot as Element).querySelectorAll(sel));
  } catch (e) {
    // :scope unsupported fallback — strip the combinator and filter to direct children.
    const bare = selector.replace(/^\s*>\s*/, '');
    const all = Array.prototype.slice.call((scopeRoot as Element).querySelectorAll(bare)) as Element[];
    nodes = all.filter((n) => n.parentNode === scopeRoot);
  }
  return nodes;
}
